module.exports = __webpack_public_path__ + "img/why-icon-3.31142759.svg";